import {
  BaseQueryFn,
  createApi,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react"
import {
  GetChannelsReq,
  GetChannelsRes,
  IChannel,
  IUpdateChannelReq,
  IUpdateChannelRes,
  GetEventLogsByChannelRes,
} from "../../interface/interface"
import {
  dynamicMiddlewaresInstance,
  registerReducer,
  RootState,
} from "@/core/store"
import { baseQueryWithReauth } from "@/modules/app/store"
import { EndpointBuilder } from "@reduxjs/toolkit/dist/query/endpointDefinitions"

const tagTypes = ["Channels", "Channel"] as const

const reducerPath: string = "channelApi"
export const baseTGStatApiURL = new URL(
  import.meta.env.REACT_APP_POSTBOT_API,
  window.location.origin,
).toString()
const baseQuery: BaseQueryFn = fetchBaseQuery({
  baseUrl: `${
    baseTGStatApiURL.endsWith("/") ? baseTGStatApiURL : baseTGStatApiURL + "/"
  }`,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.token
    if (token) {
      headers.set("authorization", `Bearer ${token}`)
    }
    return headers
  },
})

type ApiEndpointBuider = EndpointBuilder<
  typeof baseQuery,
  (typeof tagTypes)[number],
  typeof reducerPath
>

const endpoints = (build: ApiEndpointBuider) => ({
  channels: build.query<GetChannelsRes, GetChannelsReq>({
    query: ({ queryParams }) => ({
      url: `channel`,
      method: "GET",
      params: queryParams,
    }),
    // transformResponse: (data: IChannel[]) =>
    //   data.sort((l, r) =>
    //     ["kicked", "left", "restricted"].includes(l.status) ? 1 : -1,
    //   ),
    providesTags: ["Channels"],
  }),
  channel: build.query<IChannel, string>({
    query: (id) => ({
      url: `channel/${id}`,
      method: "GET",
    }),
    providesTags: ["Channel"],
  }),
  updateChannel: build.mutation<IUpdateChannelRes, IUpdateChannelReq>({
    query: ({ body, pathParams: { id } }) => ({
      url: `channel/${id}`,
      body,
      method: "PATCH",
    }),
    invalidatesTags: ["Channels", "Channel"],
  }),
  eventLogsByChannel: build.query<GetEventLogsByChannelRes, string>({
    query: (channelId) => ({
      url: `event-log/channel/${channelId}`,
      method: "GET",
      params: { limit: 100 },
    }),
    providesTags: ["Channel"],
  }),
})

export const channelApi = createApi({
  reducerPath,
  tagTypes,
  baseQuery: baseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    ...endpoints(build),
  }),
})
dynamicMiddlewaresInstance.addMiddleware(channelApi.middleware)
registerReducer(channelApi.reducerPath, channelApi.reducer)

export const {
  useChannelsQuery,
  useChannelQuery,
  useUpdateChannelMutation,
  useEventLogsByChannelQuery,
} = channelApi
